import React from 'react';

import Pill from 'components/Misc/Pill';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useWebinarProfileStore } from 'store/webinar/useWebinarProfileStore';

const Course = () => {
	// Use exam's profile store
	const [subject, course] = useWebinarProfileStore(state => [state.subject, state.course]);

	return (
		<Container className="p-4 flex items-start">
			<div className="flex-1 flex items-center">
				<Title
					title={course.title}
					subtitle={subject.title}
					className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
				/>

				<div className="ml-3 flex space-x-2">
					<Pill
						name={`${course.hours}h`}
						theme="informative"
					/>

					<Button
						small
						square
						icon="link"
						to={`/courses/${course.id}`}
					/>
				</div>
			</div>
		</Container>
	);
};

export default Course;